import { Routes, Route } from "react-router-dom";

import Login from "../../features/authentication/pages/Login";
import ForgotPassword from "../../features/authentication/pages/ForgotPassword";
import MainDashboard from "../../features/dashboard/pages/MainDashboard";
import EtdDashboard from "../../features/dashboard/pages/EtdDashboard";
import Assessment from "../../features/assessment/pages/Assessment";
import Approval from "../../features/approval/pages/Approval";
import PO1Component from "../../features/po1/pages/PO1";
import Administration from "../../features/administration/pages/Administration";
import GlobalAdmin from "../../features/administration/pages/GlobalAdmin";
import ApplicationMngt from "../../features/administration/components/ApplicationMngt";
import EditUser from "../../features/administration/components/EditUser";
import Enquiry from "../../features/enquiry/pages/Enquiry";
import Reports from "../../features/reports/pages/Reports";
import UnlockDocument from "../../features/unlock/pages/UnlockDocument";
import UnlockApplication from "../../features/unlock/pages/UnlockApplication";
import Accountant from "../../features/accountant/pages/Accountant";
import ViewDetails from "../../features/application-details/components/ViewDetails";
import SearchedViewDetails from "../../features/application-details/components/SearchedViewDetails";
import NotFound from "../../shared/components/NotFound";

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/dashboard" element={<MainDashboard />} />
      <Route path="/etd" element={<EtdDashboard />} />
      <Route path="/assessment" element={<Assessment />} />
      <Route path="/viewDetails" element={<ViewDetails />} />
      <Route path="/viewSearchedDetails" element={<SearchedViewDetails />} />
      <Route path="/globaladmin" element={<GlobalAdmin />} />
      <Route path="/approval" element={<Approval />} />
      <Route path="/po1" element={<PO1Component />} />
      <Route path="/administration" element={<Administration />} />
      <Route path="/applicationmngt" element={<ApplicationMngt />} />
      <Route path="/edituser" element={<EditUser />} />
      <Route path="/enquiry" element={<Enquiry />} />
      <Route path="/unlockDoc" element={<UnlockDocument />} />
      <Route path="/unlockApp" element={<UnlockApplication />} />
      <Route path="/accountant" element={<Accountant />} />
      <Route path="/reports" element={<Reports />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default AppRoutes;
